import * as React from "react";
import { toast } from "sonner";
import { flushOutbox, listOutbox, type OutboxItem } from "@/lib/offlineOutbox";
import { useOnlineStatus } from "@/hooks/useOnlineStatus";

/** Online visszatéréskor automatikus flush + számláló a UI-hoz. */
export function useOfflineOutbox() {
  const online = useOnlineStatus();
  const [items, setItems] = React.useState<OutboxItem[]>([]);
  const [flushing, setFlushing] = React.useState(false);

  const refresh = React.useCallback(async () => {
    setItems(await listOutbox());
  }, []);

  React.useEffect(() => {
    void refresh();
  }, [refresh]);

  React.useEffect(() => {
    if (!online) return;
    let cancelled = false;
    setFlushing(true);
    void flushOutbox()
      .then(async (r) => {
        if (cancelled) return;
        if (r.ok > 0) toast.success(`${r.ok} offline tétel szinkronizálva.`);
        if (r.failed > 0) toast.error(`${r.failed} offline tétel sikertelen — újrapróbáljuk később.`);
        await refresh();
      })
      .finally(() => {
        if (!cancelled) setFlushing(false);
      });
    return () => {
      cancelled = true;
    };
  }, [online, refresh]);

  return { items, count: items.length, flushing, refresh };
}
